/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type React from 'react';
import type { NewCoreIconProps } from '@atlaskit/icon/base-new';

import QueuePopOutIcon from '@atlaskit/icon-lab/core/queue-pop-out';
import QueuePopInIcon from '@atlaskit/icon-lab/core/queue-pop-in';

export const PopoutIcon: React.FC<NewCoreIconProps> = QueuePopOutIcon;
export const PopinIcon: React.FC<NewCoreIconProps> = QueuePopInIcon;
